import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SystemUnavailableComponent } from './components/system-unavailable/system-unavailable.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { FlexLayoutModule } from '@angular/flex-layout';
import { PlannedOutageToolbarComponent } from './components/planned-outage-toolbar/planned-outage-toolbar.component';
import { StickyToolbarComponent } from './components/sticky-toolbar/sticky-toolbar.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatToolbarModule } from '@angular/material/toolbar';
import { LawyerInfoViewComponent } from './components/lawyer-info-view/lawyer-info-view.component';
import { MatTableModule } from '@angular/material/table';
import { StickyActionToolbarComponent } from './components/sticky-action-toolbar/sticky-action-toolbar.component';
import { SchedulerNavigationComponent } from './components/scheduler-navigation/scheduler-navigation.component';
import { SchedulerModule } from '@progress/kendo-angular-scheduler';
import {
  DateInputsModule,
  DatePickerModule,
  TimePickerModule,
} from '@progress/kendo-angular-dateinputs';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { ActionSummaryViewComponent } from './components/action-summary-view/action-summary-view.component';
import { ActionPartiesViewComponent } from './components/action-parties-view/action-parties-view.component';
import { SingleRowPanelComponent } from './components/single-row-panel/single-row-panel.component';
import { HearingDateViewComponent } from './components/hearing-date-view/hearing-date-view.component';
import { IncompletePipe } from './pipes/incomplete.pipe';
import { SectionIntroComponent } from './components/section-intro/section-intro.component';
import { MultiRowPanelComponent } from './components/multi-row-panel/multi-row-panel.component';
import { ActionTypeViewComponent } from './components/action-type-view/action-type-view.component';
import { HearingDetailsViewComponent } from './components/hearing-details-view/hearing-details-view.component';
import { RouterModule } from '@angular/router';
import { BookingSummaryViewComponent } from './components/booking-summary-view/booking-summary-view.component';
import { MatDividerModule } from '@angular/material/divider';
import { CalloutComponent } from './components/callout/callout.component';
import { SigninInfoDialogComponent } from './dialogs/signin-info-dialog/signin-info-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatPaginatorModule } from '@angular/material/paginator';
import { CommonDashboardTableComponent } from './components/common-dashboard-table/common-dashboard-table.component';
import { ActionHearingTabCardViewComponent } from './components/action-hearing-tab-card-view/action-hearing-tab-card-view.component';
import { AngularComponentsModule } from '@abgov/angular-components';
import { HearingBadgeStatusPipe } from './pipes/hearing-badge-status.pipe';
import { HearingEndTimePipe } from './pipes/hearing-end-time.pipe';
import { HearingBadgeStatusColorPipe } from './pipes/hearing-badge-status-color.pipe';
import { HearingCommentsPipe } from './pipes/hearing-comments.pipe';
import { ActionHearingCardViewComponent } from './components/action-hearing-card-view/action-hearing-card-view.component';
import { ActionHearingCardDetailsViewComponent } from './components/action-hearing-card-details-view/action-hearing-card-details-view.component';
import { ActionNonSocPartiesViewComponent } from './components/action-non-soc-parties-view/action-non-soc-parties-view.component';
import { CommaLineBreakPipe } from './pipes/comma-line-break.pipe';
import { SideDrawerComponent } from './components/side-drawer/side-drawer.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ActionHearingCardMaterialsViewComponent } from './components/action-hearing-card-materials-view/action-hearing-card-materials-view.component';
import { HearingAssociateMaterialsViewComponent } from './components/hearing-associate-materials-view/hearing-associate-materials-view.component';
import { MatTabsModule } from '@angular/material/tabs';
import { HearingAssociateMaterialsSystemViewComponent } from './components/hearing-associate-materials-system-view/hearing-associate-materials-system-view.component';
import { HearingAssociateMaterialsUploadViewComponent } from './components/hearing-associate-materials-upload-view/hearing-associate-materials-upload-view.component';
import { NgxFileDropModule } from 'ngx-file-drop';
import { FileUploadProgressBarComponent } from './components/file-upload-progress/file-upload-progress-bar.component';
import { HearingAssociateMaterialsUploadErrorViewComponent } from './components/hearing-associate-materials-upload-error-view/hearing-associate-materials-upload-error-view.component';
import { HearingAssociateMaterialsUploadMessagePanelViewComponent } from './components/hearing-associate-materials-upload-message-panel-view/hearing-associate-materials-upload-message-panel-view.component';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxsFormPluginModule } from '@ngxs/form-plugin';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SaveAssociateMaterialsDialogComponent } from './dialogs/save-associate-materials-dialog/save-associate-materials-dialog.component';
import { ConfirmationDialogComponent } from './dialogs/confirmation-dialog/confirmation-dialog.component';
import { SaveAssociateMaterialsFailedDialogComponent } from './dialogs/save-associate-materials-failed-dialog/save-associate-materials-failed-dialog.component';
import { JscActionSearchCardViewComponent } from './components/jsc-action-search-card-view/jsc-action-search-card-view.component';
import { ReduceStyleOfCausePipe } from './pipes/reduce-style-of-cause.pipe';
import { ToJudicialCentrePipe } from './pipes/to-judicial-centre.pipe';
import { JsgSingleFileUploaderComponent } from './components/single-file-uploader/single-file-uploader.component';
import { JsgFileUploadCardComponent } from './components/file-upload-card-view/file-upload-card-view.component';
import { FileUploadDetailViewComponent } from './components/file-upload-detail/file-upload-detail.component';
import { JscActionSummaryViewComponent } from './components/jsc-action-summary-view/jsc-action-summary-view.component';
import { JscConfirmActionViewComponent } from './components/jsc-confirm-action-view/jsc-confirm-action-view.component';
import { JscHearingDetailsViewComponent } from './components/jsc-hearing-details-view/jsc-hearing-details-view.component';
import { JscHearingRequestDocumentsViewComponent } from './components/jsc-hearing-request-documents-view/jsc-hearing-request-documents-view.component';
import { JscActionHearingCardDetailsViewComponent } from './components/jsc-action-hearing-card-details-view/jsc-action-hearing-card-details-view.component';
import { ActionHearingHistoryViewComponent } from './components/action-hearing-history-view/action-hearing-history-view.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { ActionHearingDetailsTileViewComponent } from './components/action-hearing-details-tile-view/action-hearing-details-tile-view.component';
const SHARED_PIPES = [
  SafeHtmlPipe,
  IncompletePipe,
  HearingBadgeStatusPipe,
  HearingEndTimePipe,
  HearingBadgeStatusColorPipe,
  HearingCommentsPipe,
  CommaLineBreakPipe,
  ReduceStyleOfCausePipe,
  ToJudicialCentrePipe,
];
const SHARED_COMPONENTS = [
  SystemUnavailableComponent,
  PlannedOutageToolbarComponent,
  StickyToolbarComponent,
  StickyActionToolbarComponent,
  LawyerInfoViewComponent,
  CalloutComponent,
  SigninInfoDialogComponent,
  ActionPartiesViewComponent,
  ActionSummaryViewComponent,
  SchedulerNavigationComponent,
  SingleRowPanelComponent,
  HearingDateViewComponent,
  SectionIntroComponent,
  MultiRowPanelComponent,
  ActionTypeViewComponent,
  HearingDetailsViewComponent,
  BookingSummaryViewComponent,
  CommonDashboardTableComponent,
  ActionHearingTabCardViewComponent,
  ActionHearingCardViewComponent,
  ActionHearingCardDetailsViewComponent,
  ActionNonSocPartiesViewComponent,
  ActionHearingHistoryViewComponent,
  ActionHearingDetailsTileViewComponent,
  SideDrawerComponent,
  ActionHearingCardMaterialsViewComponent,
  HearingAssociateMaterialsViewComponent,
  HearingAssociateMaterialsSystemViewComponent,
  HearingAssociateMaterialsUploadViewComponent,
  HearingAssociateMaterialsUploadErrorViewComponent,
  HearingAssociateMaterialsUploadMessagePanelViewComponent,
  FileUploadProgressBarComponent,
  SaveAssociateMaterialsDialogComponent,
  ConfirmationDialogComponent,
  SaveAssociateMaterialsFailedDialogComponent,
  JscActionSearchCardViewComponent,
  JsgSingleFileUploaderComponent,
  JsgFileUploadCardComponent,
  FileUploadDetailViewComponent,
  JscActionSummaryViewComponent,
  JscConfirmActionViewComponent,
  JscHearingDetailsViewComponent,
  JscHearingRequestDocumentsViewComponent,
  JscActionHearingCardDetailsViewComponent,
];
const MATERIAL_MODULES = [
  MatButtonModule,
  MatDialogModule,
  MatIconModule,
  MatInputModule,
  MatProgressSpinnerModule,
  MatToolbarModule,
  MatTableModule,
  MatPaginatorModule,
  MatDividerModule,
  MatSidenavModule,
  MatTabsModule,
  MatSelectModule,
  FormsModule,
  ReactiveFormsModule,
  NgxsFormPluginModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatCheckboxModule,
  MatExpansionModule,
];

const KENDO_MODULES = [
  SchedulerModule,
  DatePickerModule,
  TimePickerModule,
  ButtonModule,
  DateInputsModule,
];

@NgModule({
  declarations: [
    SHARED_COMPONENTS,
    SHARED_PIPES,
    ActionNonSocPartiesViewComponent,
  ],
  imports: [
    CommonModule,
    FlexLayoutModule,
    RouterModule,
    AngularComponentsModule,
    NgxFileDropModule,
    MATERIAL_MODULES,
    KENDO_MODULES,
  ],
  exports: [SHARED_COMPONENTS, SHARED_PIPES],
})
export class SharedModule {}
//
